
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 17","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.844 4.488L4.375 9.832v5.73c0 .317.246.563.563.563h3.937c.281 0 .527-.246.527-.563v-3.374c0-.282.282-.563.563-.563h2.25c.316 0 .562.281.562.563v3.374c0 .317.282.563.563.563h3.973a.578.578 0 00.562-.563V9.797l-6.504-5.309a.38.38 0 00-.246-.105.399.399 0 00-.281.105zm10.23 3.621l-2.918-2.425V.832a.427.427 0 00-.422-.422h-1.968a.406.406 0 00-.422.422v2.531L12.18.762C11.934.55 11.44.41 11.09.41c-.317 0-.809.14-1.055.352L1.141 8.109a.42.42 0 00-.176.317c0 .105.07.21.105.281l.914 1.09c.07.07.211.14.317.14a.47.47 0 00.281-.105l8.262-6.785a.399.399 0 01.281-.106.38.38 0 01.246.106l8.262 6.785c.07.07.21.105.281.105.105 0 .246-.07.316-.14l.915-1.09c.035-.07.105-.176.105-.281a.42.42 0 00-.176-.317z"}})])
          )
        }
      }
    